import { call, put, select } from 'typed-redux-saga'
import { AnyAction } from 'redux'

import services from '@services'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { ErrorCodes } from '@utils/enums'
import { ApplicationState } from '@store/types'
import { BridgeService } from '@services/bridge'
import { HttpStatus } from '@services/base'
import { logout } from '@utils/functions'
import { ErroType } from '@utils/types'

import { RefinancingBeginRequestPayload } from '../types'
import { refinancingBeginRequest } from '../actions'

export default function* postRefinancingBeginSaga(action: AnyAction) {
  const payload = action.payload as RefinancingBeginRequestPayload

  try {
    const { accessToken } = yield* select((state: ApplicationState) => state.session)

    const response = yield* call(services.postRefinancingBeginService, accessToken)
    yield put(
      setLastServiceResponse({
        code: String(response.status ?? 'OK'),
        serviceName: 'postRefinancingBeginService',
      }),
    )

    if (response.status === 201) {
      yield call(payload.successCallback)
    } else {
      yield call(payload.errorCallback)
    }
  } catch (error) {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'postRefinancingBeginService' }))
    const erroTyped = error as ErroType

    if (BridgeService.isBrowser() && erroTyped.status === HttpStatus.UNAUTHORIZED) {
      yield put(
        showError({
          title: 'Sessão expirada',
          message: 'Efetue o login novamente.',
          actionTitle: 'Continuar',
          functionCallback: () => logout(),
        }),
      )
    } else {
      yield put(
        showError({
          title: 'Erro ao iniciar refinanciamento',
          message: 'Ocorreu um erro ao iniciar o processo de refinanciamento.',
          actionTitle: 'Tentar Novamente',
          code: ErrorCodes.RE_001_CONTRATOS,
          actionCallback: () => refinancingBeginRequest(payload),
        }),
      )
    }
  }
}
